import type { ReactNode } from 'react';
import { Button, Center, Heading, Image, Text, VStack } from '@/ui';

type Props = {
  title: string;
  message: ReactNode;
  reloadLabel: string;
  onReload: () => void;
  isInContent?: boolean;
};

export const ErrorScreen = ({
  title,
  message,
  reloadLabel,
  onReload,
  isInContent,
}: Props) => {
  return (
    <Center flex="1">
      <VStack borderRadius="12" px="12" py="8" textAlign="center" w="500px">
        {!isInContent && (
          <Image alt="Agenda Hero mascot" mb="2" src="/mascot.png" w="140px" />
        )}
        <Heading fontSize="24px">{title}</Heading>
        <Text pb="4">{message}</Text>
        <Button variant="secondary" onClick={onReload}>
          {reloadLabel}
        </Button>
      </VStack>
    </Center>
  );
};
